// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.btn {
  background: #c94b4b;
  color: #fff;
  border: 0;
  padding: 12px 18px;
  border-radius: 6px;
  cursor: pointer;
}

.popover {
  position: absolute;
  width: 260px;
  background: #fff;
  border: 1px solid #dcdcdc;
  border-radius: 6px;
  box-shadow: 0 8px 24px rgba(0,0,0,.12);
  z-index: 9999;
}

.popover__title {
  font-weight: 600;
  padding: 10px 12px;
  border-bottom: 1px solid #eee;
}

.popover__content {
  padding: 10px 12px;
  color: #333;
  line-height: 1.4;
}

.popover::after {
  content: "";
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -8px;
  border-width: 8px 8px 0 8px;
  border-style: solid;
  border-color: #fff transparent transparent transparent;
  filter: drop-shadow(0 -1px 0 #dcdcdc);
}`, "",{"version":3,"sources":["webpack://./src/css/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,2BAA2B;EAC3B,mBAAmB;EACnB,sDAAsD;EACtD,qCAAqC;AACvC","sourcesContent":[".container {\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.btn {\n  background: #c94b4b;\n  color: #fff;\n  border: 0;\n  padding: 12px 18px;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.popover {\n  position: absolute;\n  width: 260px;\n  background: #fff;\n  border: 1px solid #dcdcdc;\n  border-radius: 6px;\n  box-shadow: 0 8px 24px rgba(0,0,0,.12);\n  z-index: 9999;\n}\n\n.popover__title {\n  font-weight: 600;\n  padding: 10px 12px;\n  border-bottom: 1px solid #eee;\n}\n\n.popover__content {\n  padding: 10px 12px;\n  color: #333;\n  line-height: 1.4;\n}\n\n.popover::after {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  bottom: -8px;\n  border-width: 8px 8px 0 8px;\n  border-style: solid;\n  border-color: #fff transparent transparent transparent;\n  filter: drop-shadow(0 -1px 0 #dcdcdc);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
